(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupStatusDialogController', FollowupStatusDialogController);

    FollowupStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FollowupStatus'];

    function FollowupStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FollowupStatus) {
        var vm = this;
        vm.followupStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:followupStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.followupStatus.id !== null) {
                FollowupStatus.update(vm.followupStatus, onSaveSuccess, onSaveError);
            } else {
                FollowupStatus.save(vm.followupStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
